import { useState, useCallback } from "react";

export default function useModals() {
  const [openEbookModal, setOpenEbookModal] = useState(false);
  const [openGetDemoModal, setOpenGetDemoModal] = useState(false);
  const [openCalendlyModal, setOpenCalendlyModal] = useState(false);

  // Optional convenience functions
  const openModal = useCallback((type) => {
    if (type === "ebook") setOpenEbookModal(true);
    if (type === "getDemo") setOpenGetDemoModal(true);
    if (type === "calendly") setOpenCalendlyModal(true);
  }, []);

  const closeModal = useCallback((type) => {
    if (type === "ebook") setOpenEbookModal(false);
    if (type === "getDemo") setOpenGetDemoModal(false);
    if (type === "calendly") setOpenCalendlyModal(false);
  }, []);

  const closeAll = useCallback(() => {
    setOpenEbookModal(false);
    setOpenGetDemoModal(false);
    setOpenCalendlyModal(false);
  }, []);

  return {
    openEbookModal,
    setOpenEbookModal,
    openGetDemoModal,
    setOpenGetDemoModal,
    openCalendlyModal,
    setOpenCalendlyModal,
    openModal,
    closeModal,
    closeAll,
  };
}
